import React, { useEffect } from 'react';
import { shapes } from '@greenville/framework';
import { inject, observer } from 'mobx-react';

import TenantsModel from './models/TenantsModel';
import GraphEditor from './GraphEditor';

const Agentic = ({ tenantState }) => {
  useEffect(() => {
    if (tenantState.tenantList && tenantState.tenantList.length === 0) {
      tenantState.fetchTenantsList();
    }
  }, [tenantState.tenantList]);

  return <GraphEditor />;
};

Agentic.propTypes = {
  tenantState: shapes.modelOf(TenantsModel).isRequired
};

export default inject('tenantState')(observer(Agentic));
